import { PropsWithChildren, ReactElement } from "react";
import styles from "./AnalyticsDetailedList.module.less";
import classNames from "classnames";
import { Anchor } from "client/Components";
import { StatisticsFormatter, useStatisticsFormatters } from "./common";
import { isNotNilOrWhiteSpace } from "client/Misc/utils";

export const AnalyticsDetailedList = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<ol className={styles.root}>
			{children}
		</ol>
	);
};
AnalyticsDetailedList.displayName = "AnalyticsDetailedList";

export type AnalyticsDetailedListItemProps = {
	thumbnail: ReactElement;
	title: string;
	subtitle?: string;
	isDisabled?: boolean;
	counter: number;
	onClick?: () => void;
};

const Item = (props: AnalyticsDetailedListItemProps): ReactElement => {
	const {
		thumbnail,
		isDisabled = false,
		title,
		subtitle,
		counter,
		onClick
	} = props;

	const formatter: StatisticsFormatter = useStatisticsFormatters();

	const renderContent = (): ReactElement => {
		return (
			<>
				<div>{thumbnail}</div>
				<div className={styles.content}>
					<div className={styles.title}>{title}</div>
					{isNotNilOrWhiteSpace(subtitle) && (
						<div className={styles.subtitle}>{subtitle}</div>
					)}
				</div>
				<div
					className={styles.counter}
					title={formatter(counter, true)}
				>
					{formatter(counter)}
				</div>
			</>
		);
	};

	if (onClick) {
		return (
			<li>
				<Anchor
					className={classNames(
						styles.item,
						{[styles.item_disabled]: isDisabled},
						styles.item_clickable
					)}
					onClick={onClick}
				>
					{renderContent()}
				</Anchor>
			</li>
		);
	}

	return (
		<li
			className={classNames(
				styles.item,
				{[styles.item_disabled]: isDisabled}
			)}
		>
			{renderContent()}
		</li>
	);
};
Item.displayName = "AnalyticsDetailedList.Item";

AnalyticsDetailedList.Item = Item;